import AppLayout from '@/layout/AppLayout.vue'

const Vote = () => import('@/view/vote/Vote.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/vote',
        component: Vote,
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
